// GET SITE IDs
export const GET_SITE_IDS = (propertyId: any, clientId: any) => `/cms/config/siteids?property-id=${propertyId}&client-id=${clientId}`;
// GET CLUB MEMBERSHIP FOR PLAYERS
export const GET_CLUB_MEMBERSHIP_FOR_PLAYERS = (propertyId: any, clientId: any) => `/cms/config/club-types?property-id=${propertyId}&client-id=${clientId}`;
// GET PLAYER TYPE CLUB RULES
export const GET_PLAYER_TYPE_CLUB_RULES = (propertyId: any, clientId: any) => `/cms/config/playertype-clubrules?property-id=${propertyId}&client-id=${clientId}`;
// GET LIST OF OFFER TYPES
export const GET_LIST_OF_OFFER_TYPES = (propertyId: any, clientId: any) => `/cms/config/offer-types?property-id=${propertyId}&client-id=${clientId}`;
